import { Injectable, OnDestroy } from '@angular/core';
import { filter, map, takeUntil } from 'rxjs/operators';
import { ResultCodeFacadeService } from '@app/facade-services/result-code/result-code-facade.service';
import { FenceFacadeService } from '@app/facade-services/fence/fence-facade.service';
import { RaceClassFacadeService } from '@app/facade-services/race-class/race-class-facade.service';
import { ClubLogoFacadeService } from '@app/facade-services/club-logo/club-logo-facade.service';
import { combineLatestWith, Subject, take } from 'rxjs';
import { PasswordService } from '@app/services/password/password.service';
import { defined, isNotEmpty } from '@app/fremework/functions';
import { UserToken } from '@app/services/password/model/user-token';
import { SelectedRaceService } from '@app/services/selected-race.service';

@Injectable({
  providedIn: 'root'
})
export class BasicDataService implements OnDestroy {
  componentId = 'BasicDataService';
  private unsubscribe$ = new Subject<void>();

  constructor(private readonly resultCodeFacadeService: ResultCodeFacadeService,
              private readonly fenceFacadeService: FenceFacadeService,
              private readonly raceClassFacadeService: RaceClassFacadeService,
              private readonly clubLogofacadeServcie: ClubLogoFacadeService,
              private readonly passwordService: PasswordService,
              private readonly selectedRaceService: SelectedRaceService) {
  }

  init(): void {
    this.passwordService
      .tokens$
      .pipe(
        filter((tokens: UserToken[]) => isNotEmpty(tokens)),
        take(1),
        combineLatestWith(this.selectedRaceService.selectedRace$.pipe(filter(r => defined(r)))),
        map(([_, selectedRace]) => {
          this.loadBasicData(selectedRace.raceGuid);
        })
      )
      .subscribe();
  }

  private loadBasicData(raceGuid: string): void {
    this.fetchAllClubLogos();
    this.fetchFence(raceGuid);
    this.fetchRaceClasses(raceGuid);
    this.fetchAllResultCodes();
  }

  fetchAllClubLogos(): void {
    this.clubLogofacadeServcie
      .fetchAllClubLogos(this.componentId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe();
  }

  fetchAllResultCodes(): void {
    this.resultCodeFacadeService
      .fetchAllResultCodes(this.componentId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe();
  }

  fetchFence(raceGuid: string): void {
    this.fenceFacadeService
      .fetchFence(raceGuid, this.componentId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe();
  }

  fetchRaceClasses(raceGuid: string): void {
    this.raceClassFacadeService
      .fetchRaceClass(raceGuid, this.componentId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
